import {
    advertiserIdRenderer,
    lineItemIdRenderer,
    lineItemLabelIdRenderer,
    orderIdRenderer,
    orderLabelIdRenderer,
} from 'components/FieldRenderers/Renderers/dsp'
import { brandId } from 'configuration/fieldCreators/brand'
import {
    advertiserId,
    lineItemId,
    lineItemLabelId,
    lineItemType,
    orderId,
    orderLabelId,
} from 'configuration/fieldCreators/dsp'
import { ctr, impressions__sum } from 'configuration/fieldCreators/metrics/ams'
import {
    add_to_cart_clicks__sum,
    add_to_cart_views__sum,
    agency_fee_sum,
    amazon_audience_fee__sum,
    amazon_platform_fee__sum,
    atc_14_day__sum,
    atc_14_day_rate,
    atl_14_day__sum,
    atl_14_day_rate,
    brand_search_rate,
    brand_searches_clicks__sum,
    brand_searches_views__sum,
    click_throughs__sum,
    combined_ecpp,
    combined_erpm,
    combined_product_sales__sum,
    combined_purchases__sum,
    combined_purchases_clicks__sum,
    combined_purchases_rate,
    combined_purchases_views__sum,
    combined_roas,
    combined_units_sold__sum,
    detail_page_view_views__sum,
    dpv_14_day__sum,
    dpvr_14_day,
    ecp_brand_search,
    ecp_new_subscribe_and_save_14_day,
    ecp_product_review_page_visit,
    ecpatl_14_day,
    ecpc,
    ecpdpv_14_day,
    ecpm,
    ecpp,
    ecpvc,
    effective_cost_per_purchase_promoted_clicks,
    line_item_budget_cap__sum,
    new_subscribe_and_save_14_day__sum,
    new_subscribe_and_save_rate,
    new_to_brand_detail_page_view__sum,
    new_to_brand_detail_page_view_clicks__sum,
    new_to_brand_detail_page_view_rate,
    new_to_brand_detail_page_view_views__sum,
    new_to_brand_ecp_detail_page_view,
    new_to_brand_ecpp,
    new_to_brand_erpm,
    new_to_brand_product_sales_14_day__sum,
    new_to_brand_purchases_14_day__sum,
    new_to_brand_purchases_clicks__sum,
    new_to_brand_purchases_rate,
    new_to_brand_purchases_views__sum,
    new_to_brand_roas_14_day,
    new_to_brand_units_sold_14_day__sum,
    off_amazon__sum,
    off_amazon_clicks__sum,
    off_amazon_conversions__sum,
    off_amazon_cpa,
    off_amazon_cvr,
    off_amazon_erpm,
    off_amazon_purchases__sum,
    off_amazon_purchases_clicks__sum,
    off_amazon_purchases_ecpp,
    off_amazon_purchases_rate,
    off_amazon_purchases_views__sum,
    off_amazon_roas,
    off_amazon_units_sold__sum,
    off_amazon_views__sum,
    omni_channel_metrics_fee__sum,
    percent_of_purchases_new_to_brand_14_day,
    product_review_page_visits__sum,
    product_review_page_visits_clicks__sum,
    product_review_page_visits_rate,
    product_review_page_visits_views__sum,
    purchase_rate_14_day,
    purchases_14_day__sum,
    purchases_clicks__sum,
    purchases_views__sum,
    reach__sum,
    roas_14_day,
    sales_14_day__sum,
    supply_cost__sum,
    threep_fees_sum,
    total_add_to_cart_14_day__sum,
    total_add_to_cart_clicks__sum,
    total_add_to_cart_rate,
    total_add_to_cart_views__sum,
    total_add_to_list_14_day__sum,
    total_add_to_list_clicks__sum,
    total_add_to_list_rate,
    total_add_to_list_views__sum,
    total_cost__sum,
    total_detail_page_view_clicks__sum,
    total_detail_page_view_views__sum,
    total_detail_page_views_14_day__sum,
    total_dpvr_14_day,
    total_ecp_add_to_cart_14_day,
    total_ecp_add_to_list_14_day,
    total_ecp_product_review_page_visit,
    total_ecp_subscribe_and_save_14_day,
    total_ecpdpv_14_day,
    total_ecpp,
    total_erpm,
    total_fee__sum,
    total_new_to_brand_ecpp,
    total_new_to_brand_erpm,
    total_new_to_brand_product_sales_14_day__sum,
    total_new_to_brand_purchases_14_day__sum,
    total_new_to_brand_purchases_clicks__sum,
    total_new_to_brand_purchases_percent,
    total_new_to_brand_purchases_rate,
    total_new_to_brand_purchases_views__sum,
    total_new_to_brand_roas_14_day,
    total_new_to_brand_units_sold_14_day__sum,
    total_product_review_page_visits__sum,
    total_product_review_page_visits_clicks__sum,
    total_product_review_page_visits_rate,
    total_product_review_page_visits_views__sum,
    total_purchase_rate_14_day,
    total_purchases_14_day__sum,
    total_purchases_clicks__sum,
    total_purchases_views__sum,
    total_roas_14_day,
    total_sales_14_day__sum,
    total_subscribe_and_save__sum,
    total_subscribe_and_save_clicks__sum,
    total_subscribe_and_save_rate,
    total_subscribe_and_save_subscriptions_14_day__sum,
    total_units_sold_14_day__sum,
    units_sold_14_day__sum,
    video_ad_clicks__sum,
    video_complete__sum,
    video_completion_rate,
    video_midpoint__sum,
    video_start__sum,
    video_third_quartile__sum,
    viewable_impressions__sum,
} from 'configuration/fieldCreators/metrics/dsp'
import { UNDEFINED_VALUE } from 'const/formatting'
import { titleCase } from 'helpers/formatting'
import {
    DspAdvertiserGroupBy,
    DspLineItemGroupBy,
    DspLineItemLabelGroupBy,
    DspOrderGroupBy,
    DspOrderLabelGroupBy,
} from 'types'

import { makeMapping } from './helpers'

const DSP_METRICS_COLUMNS = [
    total_cost__sum({ isVisible: true }),
    supply_cost__sum({ isVisible: true }),
    impressions__sum({ isVisible: true }),
    click_throughs__sum({ isVisible: true }),

    // purchases
    purchases_14_day__sum({ isVisible: true }),

    total_purchases_14_day__sum({ isVisible: true }),

    new_to_brand_purchases_14_day__sum({ isVisible: true }),

    total_new_to_brand_purchases_14_day__sum({ isVisible: true }),

    // units sold / sales
    units_sold_14_day__sum({ isVisible: true }),
    sales_14_day__sum({ isVisible: true }),
    total_units_sold_14_day__sum({ isVisible: true }),
    total_sales_14_day__sum({ isVisible: true }),
    new_to_brand_units_sold_14_day__sum({ isVisible: true }),
    new_to_brand_product_sales_14_day__sum({ isVisible: true }),
    total_new_to_brand_units_sold_14_day__sum({ isVisible: true }),
    total_new_to_brand_product_sales_14_day__sum({
        isVisible: true,
    }),
    atc_14_day__sum({ isVisible: true }),
    atl_14_day__sum({ isVisible: true }),
    new_subscribe_and_save_14_day__sum({ isVisible: true }),
    video_start__sum({ isVisible: true }),
    video_midpoint__sum({ isVisible: true }),
    video_third_quartile__sum({ isVisible: true }),
    video_complete__sum({ isVisible: true }),
    viewable_impressions__sum({ isVisible: true }),
    amazon_audience_fee__sum({ isVisible: true }),
    amazon_platform_fee__sum({ isVisible: true }),
    total_detail_page_views_14_day__sum({ isVisible: true }),
    total_subscribe_and_save_subscriptions_14_day__sum({
        isVisible: true,
    }),
    total_add_to_cart_14_day__sum({ isVisible: true }),
    total_add_to_list_14_day__sum({ isVisible: true }),
    // Ratio
    ctr({ isVisible: true }),
    ecpm({ isVisible: true }),
    dpv_14_day__sum({ isVisible: true }),
    dpvr_14_day({ isVisible: true }),
    ecpdpv_14_day({ isVisible: true }),
    total_dpvr_14_day({ isVisible: true }),
    total_ecpdpv_14_day({ isVisible: true }),
    purchase_rate_14_day({ isVisible: true }),
    total_purchase_rate_14_day({ isVisible: true }),
    percent_of_purchases_new_to_brand_14_day({ isVisible: true }),
    roas_14_day({ isVisible: true }),
    total_roas_14_day({ isVisible: true }),
    video_completion_rate({ isVisible: true }),
    ecpvc({ isVisible: true }),
]

export const DSP_METRICS_COLUMNS_PAGES = [
    total_cost__sum({ isVisible: true }),
    supply_cost__sum({ isVisible: true }),
    impressions__sum({ isVisible: true }),
    click_throughs__sum({ isVisible: true }),

    // purchases
    purchases_14_day__sum({ isVisible: true }),
    total_purchases_14_day__sum(),
    new_to_brand_purchases_14_day__sum(),
    total_new_to_brand_purchases_14_day__sum(),

    // units sold / sales
    units_sold_14_day__sum(),
    sales_14_day__sum(),
    total_units_sold_14_day__sum(),
    total_sales_14_day__sum(),
    new_to_brand_units_sold_14_day__sum(),
    new_to_brand_product_sales_14_day__sum(),
    total_new_to_brand_units_sold_14_day__sum(),
    total_new_to_brand_product_sales_14_day__sum(),
    atc_14_day__sum(),
    atl_14_day__sum(),
    new_subscribe_and_save_14_day__sum(),
    video_start__sum(),
    video_midpoint__sum(),
    video_third_quartile__sum(),
    video_complete__sum(),
    viewable_impressions__sum(),
    amazon_audience_fee__sum(),
    amazon_platform_fee__sum(),
    total_detail_page_views_14_day__sum(),
    total_subscribe_and_save_subscriptions_14_day__sum(),
    total_add_to_cart_14_day__sum(),
    total_add_to_list_14_day__sum(),

    // Ratios
    ctr(),
    ecpm(),
    dpvr_14_day(),
    ecpdpv_14_day(),
    total_dpvr_14_day(),
    total_ecpdpv_14_day(),
    purchase_rate_14_day(),
    total_purchase_rate_14_day(),
    percent_of_purchases_new_to_brand_14_day(),
    roas_14_day(),
    total_roas_14_day(),
    video_completion_rate(),
    ecpvc(),

    threep_fees_sum(),
    add_to_cart_clicks__sum(),
    add_to_cart_views__sum(),
    atc_14_day_rate(),
    atl_14_day_rate(),
    agency_fee_sum(),
    brand_search_rate(),
    brand_searches_clicks__sum(),
    brand_searches_views__sum(),
    combined_ecpp(),
    combined_erpm(),
    combined_product_sales__sum(),
    combined_purchases__sum(),
    combined_purchases_clicks__sum(),
    combined_purchases_rate(),
    combined_purchases_views__sum(),
    combined_roas(),
    combined_units_sold__sum(),
    detail_page_view_views__sum(),
    ecpatl_14_day(),
    ecp_brand_search(),
    ecpc(),
    ecp_new_subscribe_and_save_14_day(),
    new_to_brand_ecp_detail_page_view(),
    ecp_product_review_page_visit(),
    ecpp(),
    effective_cost_per_purchase_promoted_clicks(),
    total_ecp_add_to_cart_14_day(),
    total_ecp_add_to_list_14_day(),
    total_ecp_product_review_page_visit(),
    total_ecp_subscribe_and_save_14_day(),
    line_item_budget_cap__sum(),
    new_subscribe_and_save_rate(),
    new_to_brand_detail_page_view_clicks__sum(),
    new_to_brand_detail_page_view_views__sum(),
    new_to_brand_detail_page_view__sum(),
    new_to_brand_detail_page_view_rate(),
    new_to_brand_ecpp(),
    new_to_brand_erpm(),
    new_to_brand_purchases_clicks__sum(),
    new_to_brand_purchases_views__sum(),
    new_to_brand_purchases_rate(),
    new_to_brand_roas_14_day(),
    off_amazon__sum(),
    off_amazon_cpa(),
    off_amazon_clicks__sum(),
    off_amazon_cvr(),
    off_amazon_conversions__sum(),
    off_amazon_erpm(),
    off_amazon_purchases__sum(),
    off_amazon_purchases_clicks__sum(),
    off_amazon_purchases_ecpp(),
    off_amazon_purchases_rate(),
    off_amazon_purchases_views__sum(),
    off_amazon_roas(),
    off_amazon_units_sold__sum(),
    off_amazon_views__sum(),
    omni_channel_metrics_fee__sum(),
    product_review_page_visits__sum(),
    product_review_page_visits_clicks__sum(),
    product_review_page_visits_views__sum(),
    product_review_page_visits_rate(),
    purchases_clicks__sum(),
    purchases_views__sum(),
    reach__sum(),
    total_add_to_cart_clicks__sum(),
    total_add_to_cart_views__sum(),
    total_add_to_cart_rate(),
    total_add_to_list_clicks__sum(),
    total_add_to_list_views__sum(),
    total_add_to_list_rate(),
    total_detail_page_view_clicks__sum(),
    total_detail_page_view_views__sum(),
    total_ecpp(),
    total_erpm(),
    total_fee__sum(),
    total_new_to_brand_ecpp(),
    total_new_to_brand_erpm(),
    total_new_to_brand_purchases_clicks__sum(),
    total_new_to_brand_purchases_percent(),
    total_new_to_brand_purchases_views__sum(),
    total_new_to_brand_purchases_rate(),
    total_new_to_brand_roas_14_day(),
    total_product_review_page_visits__sum(),
    total_product_review_page_visits_clicks__sum(),
    total_product_review_page_visits_views__sum(),
    total_product_review_page_visits_rate(),
    total_purchases_clicks__sum(),
    total_purchases_views__sum(),
    total_subscribe_and_save__sum(),
    total_subscribe_and_save_clicks__sum(),
    total_subscribe_and_save_rate(),
    video_ad_clicks__sum(),
]

export const DSP_METRICS_CONFIG = makeMapping(DSP_METRICS_COLUMNS)

const SPECIAL_DSP_GROUP_BY_COLUMNS = [
    brandId(),
    advertiserId<DspAdvertiserGroupBy>({
        renderOptions: { render: advertiserIdRenderer },
    }),
    orderId<DspOrderGroupBy>({
        renderOptions: { render: orderIdRenderer },
    }),

    orderLabelId<DspOrderLabelGroupBy>({
        renderOptions: { render: orderLabelIdRenderer },
    }),
    lineItemId<DspLineItemGroupBy>({
        renderOptions: { render: lineItemIdRenderer },
    }),
    lineItemType({
        dataIndex: ['line_item__line_item_type'],
        renderOptions: {
            render: ({ value }) => (value ? titleCase(value) : UNDEFINED_VALUE),
        },
    }),
    lineItemLabelId<DspLineItemLabelGroupBy>({
        renderOptions: { render: lineItemLabelIdRenderer },
    }),
]

export const SPECIAL_DSP_CAMPAIGN_GROUP_BY_COLUMNS = [
    ...SPECIAL_DSP_GROUP_BY_COLUMNS,
]

export const SPECIAL_DSP_INVENTORY_GROUP_BY_COLUMNS = [
    ...SPECIAL_DSP_GROUP_BY_COLUMNS,
]

export const SPECIAL_DSP_AUDIENCE_GROUP_BY_COLUMNS = [
    ...SPECIAL_DSP_GROUP_BY_COLUMNS,
]

const DSP_V3_METRICS = [
    threep_fees_sum({ isVisible: true }),
    add_to_cart_clicks__sum({ isVisible: true }),
    add_to_cart_views__sum({ isVisible: true }),
    atc_14_day_rate({ isVisible: true }),
    atl_14_day_rate({ isVisible: true }),
    agency_fee_sum({ isVisible: true }),
    brand_search_rate({ isVisible: true }),
    brand_searches_clicks__sum({ isVisible: true }),
    brand_searches_views__sum({ isVisible: true }),
    combined_ecpp({ isVisible: true }),
    combined_erpm({ isVisible: true }),
    combined_product_sales__sum({ isVisible: true }),
    combined_purchases__sum({ isVisible: true }),
    combined_purchases_clicks__sum({ isVisible: true }),
    combined_purchases_rate({ isVisible: true }),
    combined_purchases_views__sum({ isVisible: true }),
    combined_roas({ isVisible: true }),
    combined_units_sold__sum({ isVisible: true }),
    detail_page_view_views__sum({ isVisible: true }),
    ecpatl_14_day({ isVisible: true }),
    ecp_brand_search({ isVisible: true }),
    ecpc({ isVisible: true }),
    ecp_new_subscribe_and_save_14_day({ isVisible: true }),
    new_to_brand_ecp_detail_page_view({ isVisible: true }),
    ecp_product_review_page_visit({ isVisible: true }),
    ecpp({ isVisible: true }),
    effective_cost_per_purchase_promoted_clicks({ isVisible: true }),
    total_ecp_add_to_cart_14_day({ isVisible: true }),
    total_ecp_add_to_list_14_day({ isVisible: true }),
    total_ecp_product_review_page_visit({ isVisible: true }),
    total_ecp_subscribe_and_save_14_day({ isVisible: true }),
    line_item_budget_cap__sum({ isVisible: true }),
    new_subscribe_and_save_rate({ isVisible: true }),
    new_to_brand_detail_page_view_clicks__sum({ isVisible: true }),
    new_to_brand_detail_page_view_views__sum({ isVisible: true }),
    new_to_brand_detail_page_view__sum({ isVisible: true }),
    new_to_brand_detail_page_view_rate({ isVisible: true }),
    new_to_brand_ecpp({ isVisible: true }),
    new_to_brand_erpm({ isVisible: true }),
    new_to_brand_purchases_clicks__sum({ isVisible: true }),
    new_to_brand_purchases_views__sum({ isVisible: true }),
    new_to_brand_purchases_rate({ isVisible: true }),
    new_to_brand_roas_14_day({ isVisible: true }),
    off_amazon__sum({ isVisible: true }),
    off_amazon_cpa({ isVisible: true }),
    off_amazon_clicks__sum({ isVisible: true }),
    off_amazon_cvr({ isVisible: true }),
    off_amazon_conversions__sum({ isVisible: true }),
    off_amazon_erpm({ isVisible: true }),
    off_amazon_purchases__sum({ isVisible: true }),
    off_amazon_purchases_clicks__sum({ isVisible: true }),
    off_amazon_purchases_ecpp({ isVisible: true }),
    off_amazon_purchases_rate({ isVisible: true }),
    off_amazon_purchases_views__sum({ isVisible: true }),
    off_amazon_roas({ isVisible: true }),
    off_amazon_units_sold__sum({ isVisible: true }),
    off_amazon_views__sum({ isVisible: true }),
    omni_channel_metrics_fee__sum({ isVisible: true }),
    product_review_page_visits__sum({ isVisible: true }),
    product_review_page_visits_clicks__sum({ isVisible: true }),
    product_review_page_visits_views__sum({ isVisible: true }),
    product_review_page_visits_rate({ isVisible: true }),
    purchases_clicks__sum({ isVisible: true }),
    purchases_views__sum({ isVisible: true }),
    reach__sum({ isVisible: true }),
    total_add_to_cart_clicks__sum({ isVisible: true }),
    total_add_to_cart_views__sum({ isVisible: true }),
    total_add_to_cart_rate({ isVisible: true }),
    total_add_to_list_clicks__sum({ isVisible: true }),
    total_add_to_list_views__sum({ isVisible: true }),
    total_add_to_list_rate({ isVisible: true }),
    total_detail_page_view_clicks__sum({ isVisible: true }),
    total_detail_page_view_views__sum({ isVisible: true }),
    total_ecpp({ isVisible: true }),
    total_erpm({ isVisible: true }),
    total_fee__sum({ isVisible: true }),
    total_new_to_brand_ecpp({ isVisible: true }),
    total_new_to_brand_erpm({ isVisible: true }),
    total_new_to_brand_purchases_clicks__sum({ isVisible: true }),
    total_new_to_brand_purchases_percent({ isVisible: true }),
    total_new_to_brand_purchases_views__sum({ isVisible: true }),
    total_new_to_brand_purchases_rate({ isVisible: true }),
    total_new_to_brand_roas_14_day({ isVisible: true }),
    total_product_review_page_visits__sum({ isVisible: true }),
    total_product_review_page_visits_clicks__sum({ isVisible: true }),
    total_product_review_page_visits_views__sum({ isVisible: true }),
    total_product_review_page_visits_rate({ isVisible: true }),
    total_purchases_clicks__sum({ isVisible: true }),
    total_purchases_views__sum({ isVisible: true }),
    total_subscribe_and_save__sum({ isVisible: true }),
    total_subscribe_and_save_clicks__sum({ isVisible: true }),
    total_subscribe_and_save_rate({ isVisible: true }),
    video_ad_clicks__sum({ isVisible: true }),
]

const DSP_COMBINED_METRICS_COLUMNS = [
    ...DSP_METRICS_COLUMNS,
    ...DSP_V3_METRICS,
].sort((a, b) => a.id.localeCompare(b.id))

export const DSP_COMBINED_METRICS_CONFIG = makeMapping(
    DSP_COMBINED_METRICS_COLUMNS
)
